import {imageFallback} from 'custom-extensions/ui-directives';
import {defineCustomElement} from 'custom-extensions/ui-utils';
import {LitElement, html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-image.scss?as=stylesheet';

export class ImageComponent extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_imageLoaded: {
				state: true,
				type: Boolean
			},
			_skipTransition: {
				state: true,
				type: Boolean
			},
			alt: {
				type: String
			},
			fallback: {
				type: String
			},
			loading: {
				type: String
			},
			src: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {boolean}
		 */
		this._imageLoaded = false;

		/**
		 * @type {boolean}
		 */
		this._skipTransition = false;

		// Default values

		/**
		 * @type {string}
		 */
		this.fallback = window.mivaJS.Image_Placeholder_Product_Empty;

		/**
		 * @type {'eager'|'lazy'}
		 */
		this.loading = 'lazy';

		/**
		 * @type {string}
		 */
		this.src = '';
	}

	connectedCallback () {
		super.connectedCallback();

		const item = this.getBoundingClientRect();
		if (item.top >= 0 &&
			item.left >= 0 &&
			item.bottom <= (
				window.innerHeight ||
				document.documentElement.clientHeight) &&
			item.right <= (
				window.innerWidth ||
				document.documentElement.clientWidth)
		) {
			this.loading = 'eager';
		}
	}

	updated (changedProperties) {
		if (!this._imageLoaded && changedProperties.has('src')) {
			this.checkImageAlreadyLoaded();
		}
	}

	checkImageAlreadyLoaded () {
		const image = this.shadowRoot.querySelector('img');

		if (image && image.complete && image.naturalWidth > 0) {
			this._skipTransition = true;
			this._imageLoaded = true;
		}
	}

	handleImageLoad () {
		this._imageLoaded = true;

		this.dispatchEvent(new CustomEvent('load', {
			bubbles: true
		}));
	}

	handleImageError () {
		this._imageLoaded = true;

		this.dispatchEvent(new CustomEvent('error', {
			bubbles: true
		}));
	}

	render () {
		const classes = {
			container: true,
			'is--instant': this._skipTransition,
			'is--loaded': this._imageLoaded
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="loader"></div>
				<img src="${this.src}" alt="${this.alt}" loading="${this.loading}" @load="${this.handleImageLoad}" @error="${this.handleImageError}" ${imageFallback(this.fallback)} />
			</div>
		`;
	}
};

defineCustomElement('x-image', ImageComponent);
